import styled from '@emotion/styled'

export const ColumnWrapper = styled.div`
  width: 100%;
`
